import { Type } from 'typebox';
export const FamilyClassroomTeacher = Type.Object({
    key: Type.String({ minLength: 1 }),
    displayName: Type.String({ minLength: 1 }),
    primary: Type.Boolean()
});
export const FamilyClassroom = Type.Object({
    key: Type.String({ minLength: 1 }),
    name: Type.String({ minLength: 1 }),
    teachers: Type.Array(FamilyClassroomTeacher),
    productCodes: Type.Array(Type.String({ minLength: 1 })),
    colorIdList: Type.Array(Type.Integer())
});
